import { useGoogleOneTapLogin } from '@react-oauth/google'
import { getReferralToken } from '../helpers/referralToken'
import { apiUrl, appPath } from '../config'

export function useGoogleOneTap(
  origin: `org/super/${string}` | `org/slite/${string}`
) {
  useGoogleOneTapLogin({
    onSuccess(credentials) {
      if (!credentials.credential) {
        // eslint-disable-next-line no-console
        console.error('got no credentials from google one tap', credentials)
        return
      }
      const params = new URLSearchParams()
      params.append('jwt', credentials.credential)
      params.append('redirect', '1')
      params.append('origin', origin)
      params.append('appPath', appPath)
      const referralToken = getReferralToken()
      if (referralToken) {
        params.append('referralToken', referralToken)
      }

      window.location.href = `${apiUrl}/auth/one-tap?${params.toString()}`
    },
    onError() {
      // eslint-disable-next-line no-console
      console.error('onError')
    },
  })
}
